<template>
  <div class="baseEdit">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="0">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('futuresStrategy.collapseTitle.addStrategicTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <BasicInfo :canEdit="canEdit" ref="basicInfo" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('futuresStrategy.collapseTitle.contractTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <DetailInfo :canEdit="canEdit" ref="detailInfo" @openDialog="openDialog" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        v-if="this.$route.name.indexOf('Detail') != -1"
        type="primary"
        @click="canEdit = !canEdit"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.editToggle') }}</el-button
      >
      <el-button type="primary" @click="save()" :disabled="!canEdit" class="fixed-bottom-btn">{{
        $t('functionBtn.save')
      }}</el-button>
    </div>
  </div>
</template>
<script>
  import API from '@/api/futuresStrategy/index';
  import BasicInfo from './components/basicInfo'; // 基本信息
  import DetailInfo from './components/detailInfo'; // 匹配明细
  export default {
    name: 'baseEdit',
    components: {
      BasicInfo, // 基本信息
      DetailInfo, // 匹配明细
    },
    data() {
      return {
        activeNames: ['0', '1'],
        canEdit: true,
      };
    },
    mounted() {
      if (this.$route.query.ptcombiNo) {
        this.getDetail(this.$route.query.ptcombiNo);
      }
      if (this.$route.name.indexOf('Detail') != -1) {
        this.canEdit = false;
      }
    },
    methods: {
      openDialog(component, params) {
        /* this.$nextTick(()=>{
          this.$refs[component].resetBtnClick();
        }) */
        this.$refs[component].$refs.dialog.openDialog(params);
        //this.$refs[component].$refs.dialog.defaultVisible = true;
        //this.$refs[component].$refs.dialog.openDialog();
      },
      importDetail(allDetail) {
        this.$refs.basicInfo.baseData = allDetail.procombiContract[0];
        this.$refs.detailInfo.tableData = allDetail.orderDetail;
        this.$refs.detailInfo.baseData.puescheProductCount = allDetail.puescheProductCount;
        this.$refs.detailInfo.baseData.purchaseAmount = allDetail.puescheAmount;
        this.$refs.detailInfo.baseData.salesProductCount = allDetail.salesProductCount;
        this.$refs.detailInfo.baseData.salesAmount = allDetail.salesAmount;
      },
      async getDetail(id) {
        // 请求详情
        this.loading.startLoading();
        let res = await this.$axios.get(`${API.QUERY_PROCOMBI_CONTRACT_LISTBYID}?ptcombiNo=${id}`);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.importDetail(res.data.data);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      handleAdd(data) {
        this.tableData = [...data, ...this.$refs.detailInfo.refs.table.getTableData().fullData];
        this.updateData();
      },
      async save() {
        // 保存
        let basicInfo = this.$refs.basicInfo.exportChildData();
        let detailInfo = await this.$refs.detailInfo.exportChildData();
        if (basicInfo && detailInfo) {
          let params = {
            ...basicInfo,
            ...detailInfo,
          };
          params = this.$baseRequest.assignObj(params, 1);
          this.loading.startLoading();
          let res = await this.$axios.post(API.PROCOMBI_CONTRACT_ADD, params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({ showClose: true, type: 'success', message: res.data.msg });
              this.canEdit = false;
              this.getDetail(res.data.data.ptcombiNo);
              /* this.canEdit=false;
            this.toPath("strategicContractList", {}); */
            } else {
              this.$message({ showClose: true, type: 'error', message: res.data.msg });
            }
          }
        }
      },
      toPath(name, query) {
        // 跳转路径
        let path = {
          path: `/futuresStrategy/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
